module.exports = __webpack_public_path__ + "static/media/GA_Post_otziv 2018.11.10.d9ec725b.webp";